import Vue from "vue";
import axios from "axios";
// import Qs from "qs";
import router from "@/route";
import { Notification } from "element-ui";
import config from "./api";
// 添加请求拦截器
const service = axios.create({
  baseURL: config.BASE_URL,
  timeout: 30000
});

// request拦截器
service.interceptors.request.use(config => {
  //此处进行token等数据处理
      // 设置请求头信息
      if (sessionStorage.getItem("token")) {
        config.headers["Authorization"] =
          "Bearer" + sessionStorage.getItem("token") || "";
      } else {
        config.headers.Authorization= sessionStorage.getItem("token") || "";
      }
      return config
}, error => {
  Promise.reject(error)
});


service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(error.response.data.msg,'2222')
    if (error.response.status==401) {
      Notification({
        message: error.response.data.msg,
        type: 'error',
        duration: 5 * 1000
      })
      router.replace({path: '/login'})
      sessionStorage.removeItem('token')
    }
    Promise.reject(error)
  })



Vue.prototype.$http = service;
export default service;
